import { useState } from "react";
import { inject, observer } from "mobx-react";
import { fn_connectDlvAppInit } from "function/FnBodyDelivery";
import { Modal } from "components/modal/compound/Modal";
import FormField from "components/ui/FormField";
import { Button } from "components/ui/Button";
import warningIcon from "static-file/images/modal-warning-101.png";
import { useConnectionMutation } from "views/setting/hooks/useConnectionMutation";
import modalStore from "stores/ModalStore";

const DeliveryConnectBusiness = ({ rootStore }: { rootStore: any }) => {
  const { layerStore, settingStore } = rootStore;
  const title = layerStore.title();
  const [bizNo, setBizNo] = useState<string>("");

  const { mutate: connectionService } = useConnectionMutation(rootStore);

  const getConnectButton = () => {
    const hasConnected = ["YGY", "DDY", "OTA"].includes(layerStore.tp);
    if (hasConnected) return "가게 목록 조회";
    return "확인";
  };

  // 고객센터 전화번호
  const getPhoneNumber = () => {
    if (layerStore.tp === "WMP") return "(1833-4877)";
    else return "(1544-3583)";
  };

  // 연동 목록 조회, 네이버 로그인
  const handlePrefetchData = async (bizNo: string) => {
    connectionService(bizNo);
    settingStore.setShopBizNo(bizNo);
    setBizNo("");
  };

  const handleClose = () => {
    modalStore.closeModal("DeliveryConnectBusiness");
    fn_connectDlvAppInit(rootStore);
    setBizNo("");
  };

  return (
    <Modal.BackGround containerWidth="374px" border={true} className="relative">
      <Modal.Header title={`${title} 연동`} onClose={handleClose} />

      <Modal.Content>
        <Modal.CommonContent
          text={`${title} 연동을 위해 사업자번호를 입력해주세요`}
          className="max-w-[250px] break-keep p-0"
        />
        <FormField direction="col">
          <FormField.Label htmlFor="RegistNumDlv">사업자번호</FormField.Label>
          <FormField.Input
            id="RegistNumDlv"
            placeholder="숫자만 입력하세요"
            type="number"
            maxLength={10}
            value={bizNo}
            onChange={e => {
              if (e.target.value.length > 10) {
                return;
              }
              setBizNo(e.target.value);
            }}
          />
        </FormField>
      </Modal.Content>
      {layerStore.getLayerBizNo && (
        <FormField.Message className="text-status-warning text-sm px-4">
          <div className="flex items-start gap-2">
            <img src={warningIcon} alt="warning" className="mt-1" />
            <span>
              매장 정보와 사업자 번호가 일치하지 않습니다.
              <br />
              고객센터로 문의주세요.
              {getPhoneNumber()}
            </span>
          </div>
        </FormField.Message>
      )}
      <Modal.Bottom className="absolute bottom-0 w-full !p-0">
        <div className="w-full">
          <Modal.Divider className="!my-2 mx-4" />
          <div className="flex gap-4 py-6 px-4 w-auto">
            <Button
              type="button"
              variant="white"
              className="!bg-white !text-gray-500 !border-gray-500 !py-2 !rounded-sm"
              onClick={handleClose}
            >
              취소
            </Button>
            <Button
              type="button"
              variant={bizNo.length !== 10 ? "disabled" : "default"}
              onClick={() => handlePrefetchData(bizNo)}
              disabled={bizNo.length !== 10}
              className="!py-3 !rounded-sm"
            >
              {getConnectButton()}
            </Button>
          </div>
        </div>
      </Modal.Bottom>
    </Modal.BackGround>
  );
};

export default inject("rootStore")(observer(DeliveryConnectBusiness));
